import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { useDeviceOptions } from "@/pages/Replacement/steps/ChooseDevice/hooks/use-device-options.hook";
import { NO_KEYBOARD_LAYOUT } from "@/pages/Replacement/replacement.types";
import { useReplacementDraftStore } from "@/pages/Replacement/use-replacement-draft-store";
import { REVIEW_STRING_KEYS } from "./review.constants";
import { SummaryBlock } from "./summary-block";

export interface DeviceSummaryBlockProps {
  assetId: string;
  category: string;
  onEdit: () => void;
}

export const DeviceSummaryBlock: FC<DeviceSummaryBlockProps> = ({ assetId, category, onEdit }) => {
  const { options } = useDeviceOptions({ assetId, category });
  const { deviceId, keyboardLayout } = useReplacementDraftStore();

  const selectedOption = options.find((option) => option.id === deviceId);
  const layout =
    selectedOption && keyboardLayout && keyboardLayout !== NO_KEYBOARD_LAYOUT
      ? keyboardLayout
      : undefined;

  const lines = [
    selectedOption && `${selectedOption.make} ${selectedOption.model}`,
    selectedOption?.specsLine,
    layout && `${getString(REVIEW_STRING_KEYS.keyboardLayoutLabel)}: ${layout}`,
  ].filter((line): line is string => Boolean(line));

  return (
    <SummaryBlock
      heading={getString(REVIEW_STRING_KEYS.deviceHeading)}
      lines={lines}
      onEdit={onEdit}
      editLabel={getString(REVIEW_STRING_KEYS.edit)}
      editAccessibleName={getString(REVIEW_STRING_KEYS.editDevice)}
      dataTestId="review-device-summary"
    />
  );
};
